module.exports = __webpack_public_path__ + "static/img/indexBack.53f4f8d.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/indexBack.png
// module id = YqM0
// module chunks = 0